"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHARED_LOCALE_STRINGS = void 0;
var units_1 = __importDefault(require("./units"));
exports.SHARED_LOCALE_STRINGS = {
    UNITS: (_a = {},
        _a[units_1.default.AMPERE] = 'A',
        _a[units_1.default.MILES] = 'mi',
        _a[units_1.default.KILOMETERS_PER_HOUR] = 'km/h',
        _a[units_1.default.KILOMETERS] = 'km',
        _a[units_1.default.FOOT_PER_SECOND_SQUARED] = 'ft/s²',
        _a[units_1.default.METERS_PER_SECOND_SQUARED] = 'm/s²',
        _a[units_1.default.MILES_PER_HOUR] = 'mph',
        _a[units_1.default.FOOT] = 'ft',
        _a[units_1.default.METERS] = 'm',
        _a[units_1.default.PERCENT] = '%',
        _a[units_1.default.PERCENT_MOVING_TIME] = '% Moving Time',
        _a[units_1.default.FOOT_POUNDS] = 'ft-lbs',
        _a[units_1.default.DEGREES_PER_SECOND] = 'deg/s',
        _a[units_1.default.FAHRENHEIT] = '°F',
        _a[units_1.default.CELSIUS] = '°C',
        _a[units_1.default.MILES_PER_GALLON] = 'mpg',
        _a[units_1.default.KILOMETERS_PER_LITER] = 'km/l',
        _a[units_1.default.HP] = 'hp',
        _a[units_1.default.EVENTS_PER_1000_MILES] = 'Events per 1000 Miles',
        _a[units_1.default.EVENTS_PER_1000_KILOMETERS] = 'Events per 1000 Kilometers',
        _a[units_1.default.KILO_POUNDS] = 'k-lbs',
        _a[units_1.default.RPM] = 'rpm',
        _a[units_1.default.NEWTON_METERS] = 'nm',
        _a[units_1.default.GAL] = 'gal',
        _a[units_1.default.LITERS] = 'l',
        _a[units_1.default.VOLTS] = 'V',
        _a[units_1.default.KILOWATT] = 'kW',
        _a[units_1.default.KILOWATT_HOUR] = 'kWh',
        _a[units_1.default.EVENTS] = 'Events',
        _a[units_1.default.TONS] = 'Tons',
        _a[units_1.default.KILOWATT_HOUR_PER_KILOMETER] = 'kWh/km',
        _a[units_1.default.KILOWATT_HOUR_PER_MILE] = 'kWh/Mile',
        _a[units_1.default.SECONDS] = 's',
        _a),
    DATES: {
        TODAY: 'Today',
        THREE_DAYS: '3 days',
        SEVEN_DAYS: '7 days',
        THIS_MONTH: 'This month',
        CUSTOM_RANGE: 'Custom Range',
        MONTH_ABBREVIATIONS: [
            'Jan.',
            'Feb.',
            'Mar.',
            'Apr.',
            'May',
            'Jun.',
            'Jul.',
            'Aug.',
            'Sep.',
            'Oct.',
            'Nov.',
            'Dec.',
        ],
    },
    LABELS: {
        ACTIONS: 'ACTIONS',
        ADD: 'add',
        APPLY: 'apply',
        ASSIGN: 'assign',
        CANCEL: 'cancel',
        CLEAR: 'Clear',
        CLEAR_ALL: 'Clear All',
        CLEAR_ALL_FILTERS: 'Deselect All',
        CLONE: 'copy',
        CLOSE: 'close',
        DELETE: 'delete',
        DONE: 'done',
        EDIT: 'edit',
        ERROR: 'error',
        EVENT_GUIDE: 'Event Guide',
        FEATURED: 'FEATURED',
        FILTER_BY: 'Filter By',
        MANAGE: 'MANAGE',
        NEW: 'new',
        NO: 'NO',
        OK: 'ok',
        OF: 'of',
        PRINT: 'print',
        PRINT_PDF: 'print pdf',
        SAVE: 'save',
        SEARCH: 'search',
        SECONDS: 'Seconds',
        SELECT_ALL: 'Select All',
        SUBMIT: 'Submit',
        N_A: 'N/A',
        YES: 'YES',
        EXPORT_CSV: 'Export CSV',
        NO_RESULTS: 'No results found',
    },
    SERVICES: {
        PKG: {
            FUELECONOMY: 'Fuel Analytics',
            SAFETYSUBSCRIPTION: 'Safety Event Viewer',
            SAFETY: 'Safety Analytics',
            FOTA: 'Remote Updates - Firmware',
            POTA: 'Remote Updates - Parameters',
            DOTA: 'DDEC Over the Air',
            MAINTENANCESYSTEM: 'Maintenance System',
            VIRTUALTECHNICIAN: 'Virtual Technician',
            ZONALVIRTUALTECHNICIAN: 'Virtual Technician - Zonar',
            BENDIX: 'Video - Bendix',
            DCVC: 'Video - Detroit Connect',
            LYTX: 'Video - Lytx',
        },
        GEO: {
            CHARGERMANAGEMENT: 'Charger Management',
            FLEETSERVICECENTER: 'Fleet Service Notifications',
            OTAZONES: 'xOTA Safe Zones',
            SECURESITE: 'Worksite Security',
            WORKSITEMANAGEMENT: 'Worksite Management',
        },
    },
    VEHICLE_INFO: {
        BUILT: {
            TITLE: 'Built',
            VIN: 'VIN',
            SERIAL: 'Serial',
            UNIT_ID: 'Unit ID',
            VEHICLE_TYPE: 'Vehicle Type',
            ODOMETER: 'Odometer',
            BLUETOOTH: 'Bluetooth',
            WIFI: 'WiFi',
            REMOTE_UPDATES: 'Remote Updates',
            PARAMETER_PROFILE: 'Parameter Profile',
        },
        ENGINE_SERIAL: 'Engine Serial',
        ENGINE_TYPE: 'Engine Type',
        BATTERY: {
            TITLE: 'Battery',
            LAST_UPDATE: 'Last Update',
            STATE_OF_HEALTH: 'State of Health',
            STATE_OF_CHARGE: 'State of Charge',
            REMAINING_RANGE: 'Remaining Range',
            REMAINING_CHARGING_TIME: 'Remaining Charging Time',
            CHARGING_STATUS: 'Charging Status',
            CHARGING_STATUSES: {
                CONNECTED: 'Connected',
                CHARGING: 'Charging',
                NOT_CONNECTED: 'Not connected',
            },
            TOOLTIP_1: 'The battery information shown mirrors the data displayed on the vehicle dashboard.',
            TOOLTIP_2: 'Please note that Remaining Range is an estimated value that does not consider traffic'
                + ' and weather conditions, payload, or road topology.',
        },
    },
    PAGINATION: {
        ITEMS_5: '5 items per page',
        ITEMS_10: '10 items per page',
        ITEMS_20: '20 items per page',
        ITEMS_50: '50 items per page',
        ITEMS_75: '75 items per page',
        ITEMS_100: '100 items per page',
        ITEMS_ALL: 'All items',
    },
    FAULTS: {
        CSV: {
            EVENT_ID: 'Event ID',
            FAULT_SEVERITY: 'Fault Severity',
            FAULT_CODE: 'Fault Code',
            TITLE: 'Title',
            SERIAL: 'Serial',
            UNIT_ID: 'Unit ID',
            TIME: 'Time (UTC)',
            TIME_NO_LABEL: 'Time',
            GEOFENCE: 'Geofence',
            RING_BUFFER: 'Ring Buffer',
            RING_BUFFER_1_WORD: 'Ringbuffer',
            SOURCE_ADDRESS: 'Source Address',
        },
        RING_BUFFER_SENSORS: {
            CRANKCASE_PRESSURE: 'Crankcase Pressure',
            DEF_AIR_PRESSURE: 'DEF Air Pressure',
            AFTERTREATMENT_1_DIESEL_EXHAUST_FLUID_DOSER_1_ABSOLUTE_PRESSURE: 'Aftertreatment 1 Diesel Exhaust Fluid Doser 1 Absolute Pressure',
            DEF_TANK_TEMPERATURE: 'DEF Tank Temperature',
            ENGINE_FUEL_1_INJECTOR_METERING_RAIL_2_PRESSURE: 'Engine Fuel 1 Injector Metering Rail 2 Pressure',
            DOC_INLET_TEMPERATURE: 'DOC Inlet Temperature',
            DEF_PRESSURE: 'DEF Pressure',
            COOLANT_PRESSURE: 'Coolant Pressure',
            EGR_DELTA_PRESSURE: 'EGR Delta Pressure',
            INLET_MANIFOLD_TEMPERATURE_MCM2: 'Inlet Manifold Temperature (MCM2)',
            FUEL_COMPENSATION_PRESSURE_MCM2: 'Fuel Compensation Pressure (MCM2)',
            DOC_OUTLET_TEMPERATURE: 'DOC Outlet Temperature',
            ENGINE_DESIRED_ABSOLUTE_INTAKE_MANIFOLD_PRESSURE_TURBO_BOOST_LIMIT: 'Engine Desired Absolute Intake Manifold Pressure (Turbo Boost Limit)',
            DEF_TEMPERATURE: 'DEF Temperature',
            OIL_PRESSURE: 'Oil Pressure',
            FUEL_COMPENSATION_PRESSURE_CPC2: 'Fuel Compensation Pressure (CPC2)',
            RAIL_PRESSURE: 'Rail Pressure',
            CHARGE_AIR_COOLER_OUTLET_TEMPERATURE: 'Charge Air Cooler Outlet Temperature',
            RPG_COMPENSATION: 'RPG Compensation',
            COOLANT_TEMPERATURE_CPC2: 'Coolant Temperature (CPC2)',
            AFTERTREATMENT_1_SCR_INTAKE_TEMPERATURE: 'Aftertreatment 1 SCR Intake Temperature',
            AFTERTREATMENT_1_DIESEL_EXHAUST_FLUID_DOSER_1_TEMPERATURE: 'Aftertreatment 1 Diesel Exhaust Fluid Doser 1 Temperature',
            SECOND_FLOOD_CATALYST_TEMPERATURE: 'Second Flood Catalyst Temperature',
            ENGINE_AIR_INLET_DELTA_PRESSURE: 'Engine Air Inlet Delta Pressure',
            ENGINE_OIL_TEMPERATURE: 'Engine Oil Temperature',
            ENGINE_TURBOCHARGER_LUBE_OIL_PRESSURE_1: 'Engine Turbocharger Lube Oil Pressure 1',
            SCR_OUTLET_TEMPERATURE: 'SCR Outlet Temperature',
            AVERAGE_FUEL_ECONOMY: 'Average Fuel Economy',
            COMMANDED_ENGINE_INTAKE_MANIFOLD_PRESSURE: 'Commanded Engine Intake Manifold Pressure',
            HC_DOSER_FUEL_LINE_PRESSURE: 'HC Doser Fuel Line Pressure',
            DPF_OUTLET_TEMPERATURE: 'DPF Outlet Temperature',
            COOLANT_TEMPERATURE_MCM2: 'Coolant Temperature (MCM2)',
            COOLANT_TEMPERATURE_MCM2_HR: 'Coolant Temperature (MCM2 High Resolution)',
            ENGINE_AIR_FILTER_4_DIFFERENTIAL_PRESSURE: 'Engine Air Filter 4 Differential Pressure',
            ENGINE_COOLANT_TEMPERATURE_2: 'Engine Coolant Temperature 2',
            ENGINE_AIR_FILTER_2_DIFFERENTIAL_PRESSURE: 'Engine Air Filter 2 Differential Pressure',
            INSTANTANEOUS_FUEL_ECONOMY: 'Instantaneous Fuel Economy',
            ENGINE_AIR_FILTER_3_DIFFERENTIAL_PRESSURE: 'Engine Air Filter 3 Differential Pressure',
            SCR_INLET_TEMPERATURE: 'SCR Inlet Temperature',
            WHEEL_BASED_VEHICLE_SPEED: 'Wheel-based Vehicle Speed',
            SET_SPEED_CRUISE_CONTROL: 'Set Speed Cruise Control',
            INLET_MANIFOLD_PRESSURE: 'Inlet Manifold Pressure',
            FUEL_MASS_FLOW_RATE: 'Fuel mass flow rate',
            DISTANCE_TRAVELED_WHILE_SCR_INDUCEMENT_ACTIVE: 'Distance Traveled While SCR-Inducement Active',
            HC_DOSER_INJECTION_RATE: 'HC Doser Injection Rate',
            LOW_PRESSURE_PUMP_OUTLET_PRESURE_LPPO: 'Low Pressure Pump Outlet Presure (LPPO)',
            ACTUAL_ENGINE_TORQUE_VALUE: 'Actual Engine Torque Value',
            AFTERTREATMENT_1_DIESEL_EXHAUST_FLUID_ACTUAL_DOSING_QUANTITY: 'Aftertreatment 1 Diesel Exhaust Fluid Actual Dosing Quantity',
            EXHAUST_GAS_RECIRCULATION_EGR_TEMPERATURE: 'Exhaust Gas Recirculation (EGR) Temperature',
            AMBIENT_AIR_TEMPERATURE: 'Ambient Air Temperature',
            FUEL_TEMPERATURE: 'Fuel Temperature',
            INLET_MANIFOLD_TEMPERATURE_CPC2: 'Inlet Manifold Temperature (CPC2)',
            AFTERTREATMENT_1_SCR_OUTLET_TEMPERATURE: 'Aftertreatment 1 SCR Outlet Temperature',
            ENGINE_ECU_TEMPERATURE: 'Engine ECU Temperature',
        },
    },
};
exports.default = exports.SHARED_LOCALE_STRINGS;
